// extracted by mini-css-extract-plugin
export var title = "WeaponDetail-module--title--2z9Om";
export var weapon__main = "WeaponDetail-module--weapon__main--2xilM";
export var weapon = "WeaponDetail-module--weapon--3bzsw";
export var weapon__name = "WeaponDetail-module--weapon__name--2tRNk";
export var weapon__desc = "WeaponDetail-module--weapon__desc--3ekEH";
export var weapon__img = "WeaponDetail-module--weapon__img--1Cv28";